export default {"src":"/_next/static/image/public/images/flags/flag_1758.600c16bbeecff5f2e8a7dafe8525c622.svg","height":16,"width":24};